import { PaymentCard } from '@shared/models/payment-card';

export interface PaymentCardState {
  cards: PaymentCard[];
}

export const initialPaymentCardState: PaymentCardState = {
  cards: [],
};
